import optionApi from './api/optionApi';

export const OPTION_INSERT = 'option/INSERT';
export const OPTION_LIST = 'option/LIST';

const initialState = {
	data: null,
}

export default (state = initialState, action) => {
	switch (action.type) {
		case OPTION_LIST:
			return {
				...state,
				data: action.payload
			};
		default:
			return state;
		
	}
};

export const optionInsert = (payload) => {
	return dispatch => {
		return optionApi.OptionInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const optionUpdate = (payload, id) => {
	return dispatch => {
		return optionApi.OptionUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const optionList = () => {
	return dispatch => {
		return optionApi.OptionList().then(data => {
			dispatch({
				type: OPTION_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const optionDelete = (id) => {
	return dispatch => {
		return optionApi.OptionDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};